import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';
import { cpdsMediaQueryVals } from '../../token/shared/common';
import { CpdsCardFigureProps } from '../typings';

export const aspectRatioMapping = {
  CPDS_16x9: '16/9',
  CPDS_4x3: '4/3',
  CPDS_3x2: '3/2',
  CPDS_1x1: '1/1',
  CPDS_2x3: '2/3',
  CPDS_3x4: '3/4',
  CPDS_9x16: '9/16',
};

export const CpdsCardFigure = styled.div<CpdsCardFigureProps>`
  ${({
    theme: {
      styles: { cpds },
    },
    responsive,
    aspectRatio = 'CPDS_4x3',
    ...rest
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, rest?.themeColorMode);

    const xlAspectRatio = responsive?.xl?.aspectRatio || aspectRatio;
    const lgAspectRatio = responsive?.lg?.aspectRatio || aspectRatio;
    const mdAspectRatio = responsive?.md?.aspectRatio || aspectRatio;
    const smAspectRatio = responsive?.sm?.aspectRatio || aspectRatio;
    return css`
      width: 100%;
      aspect-ratio: ${aspectRatioMapping[aspectRatio]};
      .cpds-card-component-image,
      .cpds-card-component-video {
        width: 100%;
        height: 100%;
        border-radius: ${token?.card_image_border_radius};
        object-fit: cover;
        aspect-ratio: ${aspectRatioMapping[aspectRatio]};
      }
      .cpds-image-wrapper::before {
        border-radius: ${token?.card_image_border_radius};
      }
      @media screen and (min-width: ${cpdsMediaQueryVals.cpds_large_extended_lower_limit}) {
        aspect-ratio: ${aspectRatioMapping[xlAspectRatio]};
        .cpds-card-component-image,
        .cpds-card-component-video {
          aspect-ratio: ${aspectRatioMapping[xlAspectRatio]};
        }
      }

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_large_upper_limit}) {
        aspect-ratio: ${aspectRatioMapping[lgAspectRatio]};
        .cpds-card-component-image,
        .cpds-card-component-video {
          aspect-ratio: ${aspectRatioMapping[lgAspectRatio]};
        }
      }

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit}) {
        aspect-ratio: ${aspectRatioMapping[mdAspectRatio]};
        .cpds-card-component-image,
        .cpds-card-component-video {
          aspect-ratio: ${aspectRatioMapping[mdAspectRatio]};
        }
      }

      @media screen and (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
        aspect-ratio: ${aspectRatioMapping[smAspectRatio]};
        .cpds-card-component-image,
        .cpds-card-component-video {
          aspect-ratio: ${aspectRatioMapping[smAspectRatio]};
        }
      }

      ${(props) => props?.styleOverrides}
    `;
  }}
`;
